export const DATA_PLATFORM_GUIDE = {
  DEFAULT:
    'https://www.ovhcloud.com/en-ie/identity-security-operations/logs-data-platform/',
  DE:
    'https://www.ovhcloud.com/de/identity-security-operations/logs-data-platform/',
  ES:
    'https://www.ovhcloud.com/es-es/identity-security-operations/logs-data-platform/',
  FR:
    'https://www.ovhcloud.com/fr/identity-security-operations/logs-data-platform/',
  IE:
    'https://www.ovhcloud.com/en-ie/identity-security-operations/logs-data-platform/',
  IT:
    'https://www.ovhcloud.com/it/identity-security-operations/logs-data-platform/',
  NL:
    'https://www.ovhcloud.com/nl/identity-security-operations/logs-data-platform/',
  PL:
    'https://www.ovhcloud.com/pl/identity-security-operations/logs-data-platform/',
  PT:
    'https://www.ovhcloud.com/pt/identity-security-operations/logs-data-platform/',
  GB:
    'https://www.ovhcloud.com/en-gb/identity-security-operations/logs-data-platform/',
  CA:
    'https://www.ovhcloud.com/en-ca/identity-security-operations/logs-data-platform/',
  QC:
    'https://www.ovhcloud.com/fr-ca/identity-security-operations/logs-data-platform/',
  WS:
    'https://www.ovhcloud.com/es/identity-security-operations/logs-data-platform/',
  MA:
    'https://www.ovhcloud.com/fr-ma/identity-security-operations/logs-data-platform/',
  SN:
    'https://www.ovhcloud.com/fr-sn/identity-security-operations/logs-data-platform/',
  TN:
    'https://www.ovhcloud.com/fr-tn/identity-security-operations/logs-data-platform/',
  AU:
    'https://www.ovhcloud.com/en-au/identity-security-operations/logs-data-platform/',
  SG:
    'https://www.ovhcloud.com/en-sg/identity-security-operations/logs-data-platform/',
  ASIA:
    'https://www.ovhcloud.com/asia/identity-security-operations/logs-data-platform/',
  IN:
    'https://www.ovhcloud.com/en-in/identity-security-operations/logs-data-platform/',
  WE:
    'https://www.ovhcloud.com/en-ie/identity-security-operations/logs-data-platform/',
  US:
    'https://us.ovhcloud.com/identity-security-operations/logs-data-platform/',
  WW:
    'https://www.ovhcloud.com/en/identity-security-operations/logs-data-platform/',
};

export const RETENTION = {
  FORTY_FIVE_DAYS: 'P45D',
};

export default {
  DATA_PLATFORM_GUIDE,
  RETENTION,
};
